import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

Promise.all([
  fetch(process.env.PUBLIC_URL + '/locales/en-TW.json').then((response) =>
    response.json()
  ),
  fetch(process.env.PUBLIC_URL + '/locales/en-US.json').then((response) =>
    response.json()
  ),
])
  .then(([twData, enData]) => {
    const resources = {
      'zh-TW': {
        translation: twData,
      },
      'en-US': {
        translation: enData,
      },
    }

    i18n.use(initReactI18next).init({
      resources,
      fallbackLng: 'zh-TW',
      interpolation: {
        escapeValue: false,
      },
    })
  })
  .catch((err) => {
    console.log("語言初始化失敗", err)

  })

export default i18n
